module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Mundaka-587070c2d092ef4f974a4892d75e58ee.jpg";